import { confirmPasswordSchema, createPasswordSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const changePasswordSchema = object().shape({
    current_password: stringRequiredSchema,
    new_password: createPasswordSchema,
    confirm_password: confirmPasswordSchema("new_password")
});

export default changePasswordSchema;